/* tourist/contact */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    contacts_beginDate: null,
    contacts_lastDate: null,
    contacts_datasets: [],
    contacts_country: [],
    contacts_country_filter: null,
    contacts_v1: [],
    contacts_v2: [],
    //v2
    contact_isLoading: false,
    contact_channels: {},
    contact_channels_x_date: {},
    contact_sentiment_x_location_destination: {},
    contact_table: null,
    contact_total: 0,
    contact_tbchannels: [],
    contact_tbsentiment: [],
}

// getters
const getters = {
    contact_date: state => {
        if (state.contacts_beginDate != null) {
            var _start = state.contacts_beginDate.split("T");
            var _end = state.contacts_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.contacts_beginDate, end: state.contacts_lastDate }
        }
    },
    contact_isLoading: state => {
        return state.contact_isLoading;
    },
    contacts_data_date: state => {
        if (state.contacts_beginDate !== null) {
            var _start = state.contacts_beginDate.split("T");
            var _end = state.contacts_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    contacts_datasets: state => {
        return state.contacts_datasets;
    },
    contacts_country: state => {
        return state.contacts_country;
    },
    contacts_v1: state => {
        return state.contacts_v1;
    },
    contacts_v2: state => {
        return state.contacts_v2;
    },
    contacts_country_filter: state => {
        return state.contacts_country_filter;
    },
    contact_table: state => {
        return state.contact_table;
    },
}

// actions
const actions = {
    // start /v2 actions
    V2getContactsDatasets(context, payload) {
        state.contact_isLoading = true;
        state.contacts_country_filter = null;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };

        instance.get('v2/tourist/contact', request)
            .then(response => {
                const {
                    date,
                    contact_channels,
                    contact_channels_x_date,
                    contact_sentiment_x_location_destination
                } = response.data;

                state.contacts_beginDate = date.start;
                state.contacts_lastDate = date.end;
                state.contact_channels = contact_channels;
                state.contact_channels_x_date = contact_channels_x_date;
                state.contact_sentiment_x_location_destination = contact_sentiment_x_location_destination;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "contacts_country") {
                        context.commit("V2onContactsCountry", payload);
                    } else if (stateName == "contacts_v1") {
                        context.commit("V2onContactsContactsV1", payload);
                    } else if (stateName == "contacts_v2") {
                        context.commit("V2onContactsContactsV2", payload);
                    }
                })
                state.contact_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/contacts] syntax errors under instant.get");
            })
    },
    V2getContactsCountryFilter(context, payload) {
        state.contact_isLoading = true;
        if (payload.sentiment !== undefined) {
            if (payload.sentiment !== null) {
                var rows = state.contact_sentiment_x_location_destination.rows;
                var rows_filtered = [];
                rows.forEach(function(item, index) {
                    if (item._id.contact_sentiment == payload.sentiment) {
                        rows_filtered.push(item);
                    }
                });
                payload.rows_filtered = rows_filtered;
            } else {
                payload.rows_filtered = state.contact_sentiment_x_location_destination.rows;
            }
            context.commit("V2onContactsCountry", payload);
        }
        state.contact_isLoading = false;
    },

    getContactsDatasets(context, payload) {
        // console.log("[store/tourist/contacts] getContactsDatasets() DEPRECATED - excepted contacts/13");
        state.contact_isLoading = true;
        const request = {
            params: qs.parse({
                limit: 1,
                sort: "-date"
            })
        };
        instance.get('tourist/contact', request)
            .then(response => {
                const { rows } = response.data;
                const date = rows.map((item) => { return item.date });
                var _start = moment(new Date(date)).add(-7, 'days');
                var _end = moment(new Date(date));
                var _params = {
                    start: _start.format("YYYY-MM-DD"),
                    end: _end.format("YYYY-MM-DD"),
                    sort: '-date'
                };
                // calulate _params from main_filters                
                var main_filters = payload.main_filters;
                if (main_filters !== null) {
                    if (main_filters.start !== null && main_filters.end !== null) {
                        _start = moment(new Date(main_filters.start));
                        _end = moment(new Date(main_filters.end));
                        _params.start = _start.format("YYYY-MM-DD");
                        _params.end = _end.format("YYYY-MM-DD");
                    }
                    if (main_filters.location_source !== null) {
                        _params.location_source = main_filters.location_source;
                    }
                    if (main_filters.location_destination != null) {
                        _params.location_destination = main_filters.location_destination;
                    }
                }

                // calulate _params from sub_filters
                // contact_channels, contact_sentiment, q, limit, page, sort
                _params.limit = 5;
                _params.page = 1;
                var sub_filter = payload.sub_filter;
                if (sub_filter !== null) {
                    if (sub_filter.contact_channels !== null) {
                        _params.contact_channels = sub_filter.contact_channels;
                    }
                    if (sub_filter.contact_sentiment !== null) {
                        _params.contact_sentiment = sub_filter.contact_sentiment;
                    }
                    if (sub_filter.q !== "") {
                        _params.q = sub_filter.q;
                    }
                    if (sub_filter.limit > 0) {
                        _params.limit = sub_filter.limit;
                    }
                    if (sub_filter.page > 0) {
                        _params.page = sub_filter.page;
                    }
                    if (sub_filter.sort != "") {
                        _params.sort = sub_filter.sort;
                    }
                }

                state.contacts_beginDate = moment(_start).format("YYYY-MM-DD");
                state.contacts_lastDate = moment(_end).format("YYYY-MM-DD");

                const request = {
                    params: qs.parse(_params)
                };
                instance.get('tourist/contact', request)
                    .then(response => {
                        const { contact_channels, contact_sentiment, count, rows } = response.data;
                        state.contacts_datasets = rows;
                        state.contact_total = count;
                        state.contact_tbchannels = contact_channels;
                        state.contact_tbsentiment = contact_sentiment;

                        payload.stateDatasets.forEach(function(stateName) {
                            if (stateName == "contact_table") {
                                context.commit("onContactTable", payload);
                            }
                        })
                        state.contact_isLoading = false;

                    })
                    .catch(error => {
                        console.log(error.response, "[store/tourist/contacts] syntax errors under instant.get");
                    })
            })
            .catch(error => {
                console.log(error.response);
            })
    },
}

// mutations
const mutations = {
    // start /v2 mutations
    V2onContactsCountry(state, payload) {
        // --- start dataset for jvector map
        // items = [{label1:0,label2:0,...,data:0,label:'',location_destination:'',percentage:0},...]
        var rows = state.contact_sentiment_x_location_destination.rows;
        var items = [];
        var total = 0;

        // on filtered load raw data from payload.rows_filtered
        if (payload.rows_filtered !== undefined) {
            rows = payload.rows_filtered;
        }

        rows.forEach(function(item, index) {
            var _item = {};
            var _contact_sentiment = item._id.contact_sentiment.toUpperCase();
            total += item.sum_contact;

            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_destination);

            if (pos == -1) {
                _item['label'] = item._id.location_destination;
                _item['location_destination'] = item._id.location_destination;
                _item['data'] = item.sum_contact;
                _item['POSITIVE'] = 0;
                _item['NEGATIVE'] = 0;
                _item['NEUTRAL'] = 0;
                _item[_contact_sentiment] = item.sum_contact;
                items.push(_item);
            } else {
                items[pos]['data'] += item.sum_contact;
                items[pos][_contact_sentiment] += item.sum_contact;
            }
        });

        items.forEach(function(item, index) {
            var percentage = ((item.data / total) * 100);
            items[index].percentage = percentage;
        });

        // on filtered save items data to voc_country_filter
        if (total == 0) {
            items = [];
        }

        if (payload.rows_filtered !== undefined) {
            state.contacts_country_filter = items;
        } else {
            state.contacts_country = items;
        }
        // --- end dataset for jvector map
    },

    V2onContactsContactsV1(state, payload) {
        // --- start dataset for doughnut chart
        // items = [{data:number,label:string,color:string}] 
        // const colors = [
        //     '#3241a6', //blue
        //     '#578e47', //green
        //     '#cf9a41', //yellow
        //     '#be4141', //red
        //     '#7d3b98', //purple
        // ]; 
        var colors = [];
        colors['1672'] = '#3241a6';
        colors['SOCIAL'] = '#578e47';
        colors['WEBSITE'] = '#cf9a41';

        var rows = state.contact_channels.rows;
        var items = [];
        var total = 0;

        rows.forEach(function(item, index) {
            total += item.sum_contact;
            var _color = "#e5e5e5";
            if (colors[item._id.contact_channels.toUpperCase()] !== undefined) {
                _color = colors[item._id.contact_channels.toUpperCase()];
            }
            var label = item._id.contact_channels.toUpperCase();
            var _item = { "data": item.sum_contact, "label": label, color: _color };
            if (item.sum_contact > 0)
                items.push(_item);
        });

        items.sort(function(a, b) {
            return a.label.localeCompare(b.label);
        })

        if (total == 0) {
            items = [];
        }

        state.contacts_v1 = items
        // --- end dataset for doughnut chart
    },

    V2onContactsContactsV2(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['1672'] = '#3241a6';
        colors['SOCIAL'] = '#578e47';
        colors['WEBSITE'] = '#cf9a41';

        var rows = state.contact_channels_x_date.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_contact;

            var _item = {};
            var _contact_channels = item._id.contact_channels.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['1672'] = 0;
                _item['SOCIAL'] = 0;
                _item['WEBSITE'] = 0;
                _item[_contact_channels] = item.sum_contact;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_contact_channels] != undefined) {
                    _item[_contact_channels] += item.sum_contact;
                } else {
                    _item[_contact_channels] = item.sum_contact;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.contacts_v2 = items
        // --- end dataset for stack chart
    },

    onContactTable(state, payload) {
        // --- start dataset for v-data-table
        /**
        {
            "id": "5bdbd0a235c9550010b61fea",
            "contact_name": "นายเน็ทคลับ",
            "contact_message": "ดอยอินทนนท์หนาวมาก",
            "contact_channels": "facebook",
            "contact_sentiment": "positive",
            "location_zone": "เอเชีย",
            "location_source": "ไทย",
            "location_destination": "เชียงใหม่",
            "location_destination_region": "ภาคเหนือ",
            "date": "2018-10-06T00:00:00.000Z",
            "createdAt": "2018-11-02T04:20:50.813Z",
            "updatedAt": "2018-11-02T04:20:50.813Z"
        }
        */
        var rows = state.contacts_datasets;
        var contact_datatable = {
            headers: [
                { text: 'Date', value: "date", align: 'left', style: 'width:120px;' },
                { text: 'Name', value: "contact_name", align: 'left' },
                { text: 'Message', value: "contact_message", align: 'left' },
                { text: 'Channels', value: "contact_channels", align: 'left' },
                { text: 'Sentiment', value: "contact_sentiment", align: 'left' },
                { text: 'Destination', value: "location_destination", align: 'left' },
            ],
            items: [{
                value: false,
                date: '',
                contact_name: '',
                contact_message: '',
                contact_channels: '',
                contact_sentiment: '',
                location_destination: '',
            }],
            pagination: {
                sortBy: 'date',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                date: item.date,
                contact_name: item.contact_name,
                contact_message: item.contact_message,
                contact_channels: item.contact_channels,
                contact_sentiment: item.contact_sentiment,
                location_destination: item.location_destination,
            }
            items.push(_item);
        });
        contact_datatable.items = items;
        contact_datatable.total = state.contact_total;
        contact_datatable.contact_channels = state.contact_tbchannels.sort(function(a, b) { return a.localeCompare(b) });
        contact_datatable.contact_sentiment = state.contact_tbsentiment.sort(function(a, b) { return a.localeCompare(b) });
        state.contact_table = contact_datatable;
        // --- start dataset for v-data-table
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}